import { domLoader } from "@/loader.js";

window.headerDropdownsLoaded = false;

function bindHoverDropdown(root, panel, trigger) {
  if (!root || !panel) {
    return;
  }

  let hovered = false;

  const open = () => {
    hovered = true;
    panel.classList.add("active");
    panel.setAttribute("aria-hidden", "false");
    trigger?.setAttribute("aria-expanded", "true");
  };

  const scheduleClose = () => {
    hovered = false;
    window.setTimeout(() => {
      if (!hovered) {
        panel.classList.remove("active");
        panel.setAttribute("aria-hidden", "true");
        trigger?.setAttribute("aria-expanded", "false");
      }
    }, 280);
  };

  root.addEventListener("mouseenter", open);
  root.addEventListener("mouseleave", scheduleClose);
  panel.addEventListener("mouseenter", open);
  panel.addEventListener("mouseleave", scheduleClose);

  panel.querySelectorAll("a[href]").forEach((link) => {
    link.addEventListener("click", () => {
      hovered = false;
      panel.classList.remove("active");
      panel.setAttribute("aria-hidden", "true");
      trigger?.setAttribute("aria-expanded", "false");
    });
  });
}

domLoader(function () {
  if (window.headerDropdownsLoaded) {
    return;
  }
  window.headerDropdownsLoaded = true;

  bindHoverDropdown(
    document.getElementById("header-cart-icon"),
    document.getElementById("header-cart-items"),
    null,
  );

  bindHoverDropdown(
    document.getElementById("header-profile-root"),
    document.getElementById("header-profile-dropdown"),
    document.getElementById("header-profile-trigger"),
  );
});
